import { isValidPhoneNumber } from 'libphonenumber-js';

import { PhoneNumber } from 'src/components/phone-input/types';

import { prependPlus } from '../prepend-plus';

const PHONE_NUMBER_MIN_LENGTH = 5;

export const validatePhoneNumber = (phoneNumber: PhoneNumber) => {
    const number = phoneNumber?.number || '';
    const callingCode = phoneNumber?.callingCode || '';
    const isNumberEmpty = !number || number === '+';

    if (isNumberEmpty) {
        return false;
    }

    if (callingCode) {
        const numberAndCallingCode = prependPlus(callingCode + number);
        return isValidPhoneNumber(numberAndCallingCode); // if phone number includes the code, use lib validation
    }

    return number.length > PHONE_NUMBER_MIN_LENGTH;
};
